export class FUIBreadcrumb {
    public link: string;
    public title: string;

    constructor(breadcrumb: any) {
        this.link = breadcrumb && breadcrumb.link || null;
        this.title = breadcrumb && breadcrumb.title || null;
    }
}
